$(document).ready(function () {
    setShowADS();
    handleScroll();
    copyLinkUrl();
    handleBookMark();
});

function handleBookMark() {
    document.getElementById('bookmark-btn').addEventListener('click', function () {
        alert('Nhấn Ctrl + D (Windows) hoặc Command + D (Mac) để lưu trang này vào bookmark.');
    });
}

function copyLinkUrl() {
    $('.copy__url--post').click(function () {

        var currentUrl = window.location.href;

        // Create a temporary input element
        var $tempInput = $('<input>');

        // Append the input element to the body
        $('body').append($tempInput);

        // Set the value of the input element to the current URL
        $tempInput.val(currentUrl).select();

        // Copy the value to the clipboard
        document.execCommand('copy');

        // Remove the temporary input element
        $tempInput.remove();

        // Notify the user
        alert('Copied!');
    });
}

function handleScroll() {
    $(window).scroll(function () {
        var scrollTop = $(this).scrollTop(); // Lấy vị trí hiện tại của scroll

        const topPositionElement = $('.post').offset().top;
        const heightElement = $('.post').height();

        if (scrollTop + $(window).height() / 2 > topPositionElement + heightElement) {
            $('.post__widget-box').addClass('--hidden');

            $('.ads-left-box').removeClass('--show');
            $('.ads-right-box').removeClass('--show');
        } else {
            $('.post__widget-box').removeClass('--hidden');

            if ($(window).width() <= 1400) {
                $('.ads-left-box').removeClass('--show');
                $('.ads-right-box').removeClass('--show');
            } else {
                $('.ads-left-box').addClass('--show');
                $('.ads-right-box').addClass('--show');
            }
        }
    });
}

function setShowADS() {
    $(window).resize(function () {
        // handleDisplayADS($(window).width(), $(window).scrollTop());

        const topPositionElement = $('.post').offset().top;
        const heightElement = $('.post').height();

        if ($(this).scrollTop() + $(window).height() / 2 > topPositionElement + heightElement) {
            $('.post__widget-box').addClass('--hidden');

            // if ($(window).width() < 1650) {
            $('.ads-left-box').removeClass('--show');
            $('.ads-right-box').removeClass('--show');
            // } else {
            // $('.ads-left-box').addClass('--show');
            // $('.ads-right-box').addClass('--show');
            // }
        } else {
            $('.post__widget-box').removeClass('--hidden');

            // if ($(window).width() > 1400) {
            $('.ads-left-box').addClass('--show');
            $('.ads-right-box').addClass('--show');
            // } else {
            // $('.ads-left-box').removeClass('--show');
            // $('.ads-right-box').removeClass('--show');
            // }
        }

        if ($(window).width() <= 992) {
            $('.post__widget-box').addClass('--hidden');
        } else {
            $('.post__widget-box').removeClass('--hidden');
        }


        if ($(window).width() <= 1400) {
            $('.ads-left-box').removeClass('--show');
            $('.ads-right-box').removeClass('--show');
        } else {
            $('.ads-left-box').addClass('--show');
            $('.ads-right-box').addClass('--show');
        }
    });

    // handleDisplayADS($(window).width(), $(window).scrollTop());
}

function handleDisplayADS(screenWidth, positionTop) {
    if (screenWidth > 1400) {
        showADS();
    } else {
        hiddenADS();
    }
}

function showADS() {
    $('.ads-left-box').addClass('--show');
    $('.ads-right-box').addClass('--show');
}


function hiddenADS() {
    $('.ads-left-box').removeClass('--show');
    $('.ads-right-box').removeClass('--show');
}



//ADS
var Detect;
Detect = {
    isMob: function () {
        return !window.matchMedia("(min-width: 1023px)").matches;
    },
};

window.LoadBanners = function LoadBanners(codes) {
    var ads = $(Detect.isMob() ? ".ads-mb" + " .banner" : ".ads-pc" + " .banner");

    $.each(codes, function (index, value) {
        if (value.code) {
            ads.each(function (j, val) {
                if (((val = $(val)), val.attr("ads-key") === value.pos)) {

                    if (value.code.length > 0) {
                        var pos = Math.floor(Math.random() * value.code.length);
                        val.html(value.code[pos]);
                    }
                }
            });
        }
    });
}

if (window.matchMedia("(min-width: 1023px)").matches) {
    let script = document.createElement('script');
    script.src = "/assets/frontend/ads/pc_" + ads_post + ".js?v=" + Date.now();
    document.head.appendChild(script);
} else {
    let script = document.createElement('script');
    script.src = "/assets/frontend/ads/mb_" + ads_post + ".js?v=" + Date.now();
    document.head.appendChild(script);
}


